export default "__VITE_ASSET__C_29WGTD__"